const inDevMode = (): boolean => {
  return process.env['REACT_APP_ENV'] === 'DEV'
}

export { inDevMode }
